import React, { createContext, useContext, useState } from 'react';

const AttemptContext = createContext(null);

export const AttemptProvider = ({ children }) => {
  const [attemptId, setAttemptId] = useState(null);
  const [examId, setExamId] = useState(null);
  const [wRes, setWRes] = useState(null);   // writing result
  const [sRes, setSRes] = useState(null);   // speaking result
  const [rdRes, setRdRes] = useState(null); // reading result

  const startFullExam = (newAttemptId, newExamId) => {
    setAttemptId(newAttemptId);
    setExamId(newExamId);
    setWRes(null);
    setSRes(null);
    setRdRes(null);
  };

  const reset = () => {
    setAttemptId(null);
    setExamId(null);
    setWRes(null);
    setSRes(null);
    setRdRes(null);
  };

  return (
    <AttemptContext.Provider value={{
      attemptId, examId,
      wRes, setWRes,
      sRes, setSRes,
      rdRes, setRdRes,
      startFullExam, reset,
    }}>
      {children}
    </AttemptContext.Provider>
  );
};

export const useAttempt = () => {
  const ctx = useContext(AttemptContext);
  if (!ctx) throw new Error('useAttempt must be used inside AttemptProvider');
  return ctx;
};
